export function useShareQrCode(): (qrCode: string) => void {
  return _qrcode => {};
}
